import { Button, Table, Input, Row, Col, Modal, message, Typography, Flex, Tooltip, Card } from "antd";
import { useEffect, useRef, useState, } from "react";
import Highlighter from 'react-highlight-words';
import api from "../../API";
import { DeleteOutlined, SearchOutlined, EditOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

function PackageList() {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [searchText, setSearchText] = useState('');
    const originalTableData = useRef([]);
    const columns = [
    {
      title: "Package Name",
      dataIndex: "packageName",
      width: 150,
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Package Code",
      dataIndex: "packageCode",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Description",
      dataIndex: "packageDesc",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Consulting Unit Price",
      dataIndex: "consultingUnitPrice",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
        title: "Transaction Unit Price",
        dataIndex: "transactionUnitPrice",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
    },
    {
        title: "Promotion Unit Price",
        dataIndex: "promotionUnitPrice",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
    },
    {
        title: "Package Price",
        dataIndex: "packagePrice",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
    },
    {
        title: "Total Message",
        dataIndex: "totalMessage",
        render: (text) =>
          searchText ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          )
    },
    {
      title: 'Action',
      key: 'action',
      width: 105,
      align: 'center',
      render: (_, record) => (
        <Flex justify="space-around" align="center">
            <Button 
                type="primary" 
                icon={<EditOutlined/>} 
                onClick={() => navigate(
                `/packages/edit`,
                {state: originalTableData.current.find(obj => obj.id === record.key)}
                )}>
            </Button>
            <Button 
                type="primary" danger 
                icon={<DeleteOutlined/>}
                onClick={() => {
                Modal.confirm({
                    title: 'Confirm deletion',
                    content: `Are you sure you want to delete this package?`,
                    onOk() {handleRemoveRow(record.key)},
                    maskClosable: true
                })}}></Button>
        </Flex>),
    }
  ];

  useEffect(() => {  
    setLoading(true);
    api.list_all_packages(["*"])
    .then(packages => {
        originalTableData.current = packages;
        const newPakages = packages.map(pk => ({
            key: pk.id,
            ...pk
        }))
        setDataSource(newPakages)
    }) 
    .catch(err => message.error(err.message))
    .finally(() => setLoading(false))
    }, []);
  
    function handleSearchInfo(e) {
        if(e.target.value === '') {
            setSearchText(e.target.value);
            setDataSource(originalTableData.current);
        }
        else {
            const searchData = originalTableData.current.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
            .toLowerCase()
            .includes(e.target.value.toLowerCase())));
            setSearchText(e.target.value);
            setDataSource(searchData);
        }
    }

    async function handleRemoveRow(removeKey) {
        try {
            setLoading(true);
            const responseRemove = await api.delete_packageByID(removeKey);
            originalTableData.current = originalTableData.current.filter(record => record.id !== removeKey);
            setDataSource(originalTableData.current.map(pk => ({
                key: pk.id,
                ...pk
            })))
            message.success(responseRemove.message)
        } catch (error) {
        message.error(error.message)
        } finally {
        setLoading(false);
        } 
    }
  
    return (
    <Card 
      style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
      title={
        <Typography.Title level={5} style={{margin: 0}}>Package Management</Typography.Title>
      }
      loading={loading}
      extra={
        <Link to={`/packages/new`}>
        <Button type="primary" style={{padding:15}} icon={<PlusCircleOutlined/>}>
            New Package
        </Button>
      </Link>}
    >
        <Row gutter={[16,16]}  align="middle">
          <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
            <Input 
                placeholder="Input search text"
                allowClear
                onChange={handleSearchInfo}
                suffix={<SearchOutlined />}/>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table  
              bordered
              scroll={{x: 1000}}
              columns= {columns} 
              style={{marginTop: 16, width: '100%'}} 
              dataSource={dataSource}
              loading={loading}
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: false, // Disable page size changer
                pageSize: 10, 
                showTotal: () => `Total: ${dataSource.length} items`
              }}
            />
          </Col>
        </Row>
    </Card>
    )
}

export default PackageList
